module.exports = __webpack_public_path__ + "static/media/scene_creator_onboarding_7.c450b491.jpg";